var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"cols":"12","md":"6"}},[_c('b-input-group',{staticClass:"mb-2",attrs:{"size":"lg"}},[_vm._t("left")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }